import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GridCompPersonalDataFormComponent } from './personal-data-form/grid-comp-personal-data-form.component';
import { GridCompDocumentsFormComponent } from './documents-form/grid-comp-documents-form.component';
import { ResultFormComponent } from './result-form/result-form.component';
import { ModeratorGuardService } from '../+shared/guards/moderator-guard.service';
import { PendingChangesGuard } from '../+shared/guards/pending-changes-guard.servie';
import { GridCompTechnicalFormComponent } from './technical-form/grid-comp-technical-form.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'technical-data', component: GridCompTechnicalFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'technical-data/:id', component: GridCompTechnicalFormComponent },
      { path: 'personal-data', component: GridCompPersonalDataFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'personal-data/:id', component: GridCompPersonalDataFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'documents', component: GridCompDocumentsFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'documents/:id', component: GridCompDocumentsFormComponent },
      { path: 'result/:id', component: ResultFormComponent, canActivate: [ModeratorGuardService] },
    ]),
  ],
  exports: [RouterModule],
})
export class GridCompatibilityRoutingModule {}
